import React from 'react';

const DashboardContext = React.createContext({
  toggleDrawer: () => null,
});

export default DashboardContext;
